// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"e71862e3","135":"57e1fa9a","142":"31d6cfe0","240":"3cc74790","925":"894c6070"}[chunkId] + ".chunk.css";
};